import { isEmpty } from 'lodash-es'
import moment from 'moment'
import { DATE_FORMAT, MONTHS_TH, DD_MM_YYYY_SLASH, DATE_PICKER_FORMAT } from '../constants/date'

export function getValueFromOptions(options, value) {
  if (!isEmpty(options) && value) {
    return options.filter((item) => item.value === value)[0]?.label || ''
  }
  return ''
}

export function getValueOptionsByLabel(options, label) {
  if (!isEmpty(options) && label) {
    return options.filter((item) => item.label === label)[0]?.value || ''
  }
  return ''
}

export function dateMoment(currentDate, startDate, endDate) {
  let d = moment(currentDate).format(DATE_FORMAT)
  let st = moment(startDate, DATE_FORMAT).add(-1, 'days').toDate().toLocaleDateString('en-ZA')
  let ed = moment(endDate, DATE_FORMAT).add(1, 'days').toDate().toLocaleDateString('en-ZA')

  let now = moment(d, DATE_FORMAT).toDate().toISOString('en-Za'),
    sta = moment(st, DATE_FORMAT).toDate(),
    end = moment(ed, DATE_FORMAT).toDate()

  if (moment(now).isBetween(sta, end)) {
    return false
  } else {
    return true
  }
}

export function dateMonst2(currentDate, startDate, endDate) {
  let now = moment(currentDate).format(DATE_FORMAT)
  let sta = moment(startDate, DD_MM_YYYY_SLASH).add(-1, 'days').toDate().toLocaleDateString('en-ZA')
  let end = moment(endDate, DD_MM_YYYY_SLASH).add(1, 'days').toDate().toLocaleDateString('en-ZA')

  let s = moment(sta).format(DATE_FORMAT)
  let e = moment(end).format(DATE_FORMAT)

  if (startDate && endDate && moment(now).isBetween(s, e)) {
    return false
  } else if (startDate && !endDate && moment(now).isAfter(s)) {
    return false
  } else if (endDate && !startDate && moment(now).isBefore(e)) {
    return false
  } else {
    return true
  }

  // if (moment(now).isBetween(s, e)) {
  //   return false
  // } else {
  //   return true
  // }
}

export function filterYear(startDate, endDate, beYear) {
  const staYear = startDate.substring(0, 4)
  const enYear = endDate.substring(0, 4)
  const count = beYear.length - 1
  let i = 0,
    newOptionYear = []

  if (staYear <= enYear) {
    for (let year = staYear; year <= enYear; year++) {
      newOptionYear[i] = {
        disabled: false,
        label: year.toString(),
        value: year.toString(),
        sort: i == 0 ? 'Start' : '',
      }

      if (i == count && count > 0) {
        newOptionYear[i].sort = 'End'
      }

      i++
    }
  }

  return newOptionYear
}

export function getYearMonthMapThai(startDate, endDate) {
  const map = new Map()

  const thaiMonths = [
    'มกราคม',
    'กุมภาพันธ์',
    'มีนาคม',
    'เมษายน',
    'พฤษภาคม',
    'มิถุนายน',
    'กรกฎาคม',
    'สิงหาคม',
    'กันยายน',
    'ตุลาคม',
    'พฤศจิกายน',
    'ธันวาคม',
  ]

  let start = new Date(startDate)
  const end = new Date(endDate)

  while (start <= end) {
    const year = start.getFullYear()
    const monthIndex = start.getMonth() // 0-11
    const monthValue = monthIndex + 1
    const monthLabel = thaiMonths[monthIndex]

    if (!map.has(year)) {
      map.set(year, [])
    }

    const months = map.get(year)
    // เช็กไม่ให้ซ้ำ
    if (!months.some((m) => m.value === monthValue)) {
      months.push({ value: monthValue, label: monthLabel })
    }

    start.setMonth(start.getMonth() + 1)
  }

  return map
}

export function filterMonth(startDate, endDate, onSelect) {
  const staMonth = startDate ? parseInt(startDate.substring(7, 5)) : 0
  const enMonth = endDate ? parseInt(endDate.substring(7, 5)) : 0
  const staYear = startDate ? parseInt(startDate.substring(0, 4)) : 0
  const enYear = endDate ? parseInt(endDate.substring(0, 4)) : 0

  let optionsMonth = []
  if (onSelect) {
    let eloops = endDate ? enMonth : 12
    let beloops = endDate ? 1 : staMonth

    for (let no = beloops; no <= eloops; no++) {
      optionsMonth.push(MONTHS_TH[no - 1])
    }
  } else {
    if (staYear == enYear) {
      if (staMonth <= enMonth) {
        for (let no = staMonth; no <= enMonth; no++) {
          optionsMonth.push(MONTHS_TH[no - 1])
        }
      } else {
        optionsMonth = MONTHS_TH
      }
    } else {
      optionsMonth = MONTHS_TH
    }
  }
  return optionsMonth
}

export function getActionPlanLabelByPlanCode(planOptions, code) {
  if (!isEmpty(planOptions) && code) {
    const plan = planOptions.find((item) => item.value == code.substring(0, 2))
    const workPlan = plan.children.find((item) => item.value == code.substring(0, 6))
    const actionPlan = workPlan.children.find((item) => item.value == code)
    const actionPlanLabel = actionPlan.label.substring(5, actionPlan.label.length)
    return actionPlanLabel
  }
  return ''
}

// Convert "10/07/2023 (DD/MM/YYYY)" Format To "07 ก.ย. 2566"
export function getDateThaiShort(date_string) {
  if (!isEmpty(date_string)) {
    const date = moment(date_string, DD_MM_YYYY_SLASH).toDate()

    return date.toLocaleDateString('th-TH', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
  }
  return ''
}

// Convert "07/13/2023 10:14:28" Format To "07 ก.ย. 2566"
export function getConvertDateTimeToThaiShort(date_string) {
  if (!isEmpty(date_string)) {
    const sub_date = date_string.substring(0, 10)
    const date = moment(sub_date).toDate()

    return date.toLocaleDateString('th-TH', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
  }
  return ''
}

// Convert 08-09-2023
export function getDateThaiShortDash(date_string) {
  if (!isEmpty(date_string)) {
    const date = moment(date_string, DATE_PICKER_FORMAT).toDate()

    return date.toLocaleDateString('th-TH', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
  }
  return ''
}

export function getDateThaiShortDash2(date_string) {
  if (!isEmpty(date_string)) {
    const date = moment(date_string, DATE_FORMAT).toDate()

    return date.toLocaleDateString('th-TH', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
  }
  return ''
}

export function dispayTableNumbers(page, displayLength, index) {
  return (page - 1) * displayLength + index + 1
}

export function maskIdCard(id) {
  if (isEmpty(id)) {
    return null
  }

  const digits = id.replace(/\D/g, '')
  if (digits.length !== 13) return id

  const last4 = digits.slice(-4)

  const masked = 'X'.repeat(9) + last4

  //const masked = id.slice(-4).padStart(id.length, '*');

  const formatted = masked.replace(/(.{1})(.{4})(.{5})(.{2})(.{1})/, '$1-$2-$3-$4-$5')

  return formatted
}

export function GetBudgetYear() {
  var defaultYear = new Date().getFullYear() + 543
  if (new Date().getMonth() >= 9) {
    defaultYear = new Date().getFullYear() + 543 + 1 //ปีงบประมาณ = ปีปัจุบัน+1 (เดือน 10 11 12)
  }
  return defaultYear
}